module.exports = __webpack_public_path__ + "static/hero-hcp-dosing-large-fa90010d07151bf6a67d45593df55ee3.png";